import { toast, type ToastOptions } from 'vue3-toastify';

export const useToast = () => {
  const showToast = (
    content: string,
    options: Omit<ToastOptions, 'content'> = {}
  ) => {
    toast(content, {
      hideProgressBar: true,
      theme: 'colored',
      type: 'success',
      ...options,
    });
  };

  return { showToast };
};
